// Hydrate and patch the compact Livescore markup.
import type { LayoutRuntime } from "../../../../shared/layouts/registry";

export const livescoreCompactLayout: LayoutRuntime = {
  feature: "livescore",
  layout: "compact",
  rootClass: "gwd-livescore-layout--compact",
};
